<div class="modal-overlay" tabindex="0">
  <div class="modal-container" [class.theme-light]="getCurrentTheme() === 'light'" [class.theme-dark]="getCurrentTheme() === 'dark'">
    <div class="modal-header">
      <h2>Select your background image</h2>
      <button class="close-btn" (click)="onClose()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    
    <div class="modal-content">
      <div class="banner-grid">
        @for (banner of bannerImages(); track banner; let i = $index) {
        <div 
          class="banner-item"
          [class.selected]="selectedBanner() === banner"
          [class.default]="isDefaultTheme(banner)"
          (click)="onBannerSelect(banner)">
          <img [src]="banner" [alt]="'Banner ' + (i + 1)" />
          <div class="banner-overlay">
            <i class="fas fa-check"></i>
          </div>
          @if (isDefaultTheme(banner)) {
          <div class="default-badge">
            <i class="fas fa-star"></i>
            <span>Default</span>
          </div>
          }
        </div>
        }
      </div>
    </div>
    
    <div class="modal-actions">
      <div class="footer-left">
        <div class="theme-toggle">
          <label class="toggle-switch">
            <input type="checkbox" [checked]="isThemeActive()" (change)="onThemeToggle($event)">
            <span class="slider">
              <span class="slider-knob">
                <i class="slider-icon fas fa-palette"></i>
              </span>
            </span>
          </label>
          <label class="toggle-label" (click)="onToggleLabelClick()">
            {{ isThemeActive() ? 'Theme Active' : 'Theme Disabled' }}
          </label>
        </div>
      </div>
      
      <div class="footer-right">
         <button class="btn btn-save" (click)="onSave()" [disabled]="isSaving()">
           @if (isSaving()) {
          <div class="saving-content">
            <app-spinner [size]="18"></app-spinner>
         
          </div>
          } @else {
          <span>Save Changes</span>
          }
        </button>
        <button class="btn btn-cancel" (click)="onCancel()" [disabled]="isSaving()">
          Cancel
        </button>
       
      </div>
    </div>
  </div>
</div> 